import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=6d156587&scoped=true&"
import script from "./Story.vue?vue&type=script&lang=js&"
export * from "./Story.vue?vue&type=script&lang=js&"
import style0 from "./Story.vue?vue&type=style&index=0&id=6d156587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d156587",
  null
  
)

export default component.exports